import React from 'react';
import { Route } from 'react-router-dom';
import { graphql, compose } from 'react-apollo';

import GetAdvertiserQuery from 'GraphQueries/Advertisers/GetQuery';
import NewReportQuery from 'GraphQueries/Reports/NewMutation';

import PageNavigationTabs from 'Components/Presentation/_Shared/Layout/PageNavigationTabs';
import AdvertiserEdit from 'Components/Presentation/Advertisers/AdvertiserEdit';
import ReportList from 'Components/Presentation/Advertisers/Reports/ReportList';

class AdvertiserEditContainer extends React.Component {

    static defaultProps = {
        advertiser: { name: '', postClickLookback: 30, postViewLookback: 30, costModifier: 1.25 },
        reports: [],
        loading: false,
        pageTabs: [
            { label: 'Back To List', path: 'list', includeId: false },
            { label: 'Settings', path: 'manage/settings', includeId: true },
            { label: 'Placement Classifications', path: 'manage/placement-classifications', includeId: true },
            { label: 'Reports', path: 'manage/reports', includeId: true }
        ]
    }
    state = { activeTabIndex: 1 }

    tabClickHandler = (el, key) => {
        const { history, match: { params } } = this.props;
        history.push(el.includeId ?
            `/organisations/advertisers/${params.id}/${el.path}` :
            `/organisations/advertisers/${el.path}`);
        this.setState({ activeTabIndex: key });
    }

    setActiveTab = index => {
        this.setState({ activeTabIndex: index });
    }

    saveAdvertiser = () => {
        const { advertiser } = this.state;
        this.props.onUpdate(advertiser);
    }


    render() {
        const { advertiser, reports, loading, pageTabs } = this.props;
        const { activeTabIndex } = this.state;
        return (
            <React.Fragment>
                <PageNavigationTabs pageTabs={pageTabs} activeTabIndex={activeTabIndex} onTabClick={this.tabClickHandler} />
                <Route path="/organisations/advertisers/:id/manage/settings" render={props =>
                    < AdvertiserEdit advertiser={advertiser} loading={loading} saveHandler={this.saveAdvertiser} onActivate={event => this.setActiveTab(1)} />} />
                <Route path="/organisations/advertisers/:id/manage/reports" render={props =>
                    < ReportList reports={reports} loading={loading} saveHandler={this.createReport} onActivate={event => this.setActiveTab(3)} />} />
            </React.Fragment>
        );
    }
}

export default
    compose(
        graphql(GetAdvertiserQuery, {
                options: ({ match: { params: { id } } }) => ({
                    variables: { id },
                    fetchPolicy: 'network-only',
                }),
                props: ({ data: { getAdvertiser, loading } }) => ({
                    advertiser: getAdvertiser,
                    reports: getAdvertiser && getAdvertiser.reports,
                    loading,
                }),
        }),
        graphql(NewReportQuery, {
            props: (props) => ({
                onAddReport: report => props.mutate({
                    variables: { ...report },
                    optimisticResponse: () => ({ createReport: { ...report, __typename: 'Report', version: 1 } }),
                })
            }),
            options: ({ match: { params: { id } } }) => ({
                refetchQueries: [{ query: GetAdvertiserQuery, variables: { id } }],
                update: (dataProxy, { data: { createReport } }) => {
                    const query = GetAdvertiserQuery;
                    const data = dataProxy.readQuery({ query, variables: { id } });

                    data.getAdvertiser.reports.push(createReport);

                    dataProxy.writeQuery({ query, data });
                }
            })
        })
    )(AdvertiserEditContainer);


// WEBPACK FOOTER //
// ./src/Components/Containers/Users/Edit.js